import { SurveyQuestionCheckboxItem } from 'survey-react-ui';
import { IonCheckbox, IonItem } from '@ionic/react';
import classNames from 'classnames';

import groupStyles from '../../Form/_styles/group.module.scss';

export class SurveyCheckboxItem extends SurveyQuestionCheckboxItem {
  protected renderCheckbox(isChecked: boolean): JSX.Element {
    const id = this.question.getItemId(this.item);

    // @ts-ignore
    const itemLabel = !this.hideCaption ? (
      <span className={this.cssClasses.controlLabel}>
        {this.renderLocString(this.item.locText, this.textStyle)}
      </span>
    ) : null;

    return (
      <IonItem
        lines="full"
        className={classNames(groupStyles.item, groupStyles.md)}
      >
        <IonCheckbox
          id={id}
          value={this.item.value}
          name={this.question.name + this.item.id}
          justify="start"
          labelPlacement="end"
          className={groupStyles.control}
          onIonChange={this.handleOnChange}
          checked={isChecked}
          disabled={!this.question.getItemEnabled(this.item)}
        >
          <div className={classNames(groupStyles.content)}>{itemLabel}</div>
        </IonCheckbox>
      </IonItem>
    );
  }
}
